<template>
  <nav aria-label="Page navigation example" style="text-align: center">
    <ul
      class="pagination justify-content-center"
      :class="{
        '': theme == 'venue',
        'vogue-pagination': theme == 'vogue',
      }"
    >
      <li
        @click="currentpage(currentPage - 1)"
        v-show="currentPage != 1"
        class="page-item page-prve"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" href="#">
          <svg
            class="Icon Icon--select-arrow-left"
            role="presentation"
            viewBox="0 0 11 18"
          >
            <path
              path
              d="M9.5 1.5L1.5 9l8 7.5"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="square"
            ></path>
          </svg>
        </a>
      </li>
      <li
        v-show="currentPage - 2 > -1 && currentPage != 3"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(1)">1</a>
      </li>
      <li
        v-show="currentPage - 2 > 1"
        class="page-item disabled"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" href="#">...</a>
      </li>
      <li
        v-show="currentPage - 2 >= 1 && currentPage - 2 != 2"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(currentPage - 2)">{{
          currentPage - 2
        }}</a>
      </li>
      <li
        v-show="currentPage - 2 >= 1"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(currentPage - 1)">{{
          currentPage - 1
        }}</a>
      </li>
      <li
        class="page-item active"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a
          class="page-link"
          :class="{ main_button: theme != 'vogue' }"
          @click="currentpage(currentPage)"
          >{{ currentPage }}</a
        >
      </li>
      <li
        v-show="currentPage + 1 <= total"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(currentPage + 1)">{{
          currentPage + 1
        }}</a>
      </li>
      <li
        v-show="currentPage + 2 <= total && currentPage + 2 != total - 1"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(currentPage + 2)">{{
          currentPage + 2
        }}</a>
      </li>
      <li
        v-show="currentPage + 2 < total"
        class="page-item disabled"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" href="#">...</a>
      </li>
      <li
        v-show="currentPage + 2 < total"
        class="page-item"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link" @click="currentpage(total)">{{ total }}</a>
      </li>
      <li
        @click="currentpage(currentPage + 1)"
        v-show="currentPage != total"
        class="page-item page-next"
        :class="theme == 'showtime' ? 'page-item-active2' : 'page-item-active'"
      >
        <a class="page-link">
          <svg
            class="Icon Icon--select-arrow-right"
            role="presentation"
            viewBox="0 0 11 18"
          >
            <path
              d="M1.5 1.5l8 7.5-8 7.5"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="square"
            ></path>
          </svg>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ["total", "currentPage", "path", "sortvalue", "type", "theme"],
  data() {
    return {};
  },
  methods: {
    currentpage(val) {
      window.open(this.replaceSearch("page", val), "_self");
    },
  },
};
</script>

<style scope lang='scss'>
.pagination {
  .page-item {
    cursor: pointer;
    svg {
      width: 6px;
      height: 10px;
      vertical-align: -1px;
    }
    a {
      color: #555;
    }
    .page-link {
      padding: 0.65rem 1rem;
    }
  }
  .active {
    .page-link {
      background-color: #f5f5f5 !important;
      border: 1px solid #e4e4e4;
      color: #555 !important;
    }
  }
}
.vogue-pagination {
  text-align: center;
  display: inline-flex;
  flex-wrap: wrap;
  margin: 40px 0;
  .page-item {
    .page-link {
      border: unset;
      padding: 16px 28px;
      font-size: 12px;
      line-height: 1;
      font-family: Muli;
      background-color: unset !important;
    }
  }
  .active {
    .page-link {
      background-color: unset !important;
      border-bottom: 4px solid;
      border-bottom-color: #454545;
    }
  }
  .disabled {
    .page-link {
      border: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .pagination {
    .page-item-active {
      display: none;
    }
    .page-item-active2 {
      display: inline-block;
    }
    .page-next {
      display: inline-block;
    }
    .page-prve {
      display: inline-block;
    }
  }
  .vogue-pagination {
    .page-item {
      .page-link {
        padding:  16px 20px;;
      }
    }
    .page-item-active {
      display: inline-block;
    }
  }
}
@media screen and (max-width: 575px) {
  .pagination:not(.vogue-pagination) {
    .page-item  {
      .page-link {
        padding: 4px 6px;
      }
    }
  }
}
</style>